module.exports = __webpack_public_path__ + "static/img/file_excel.30c6ef11.png";